import type { MonthStats } from './types'

// 'YYYY-MM' <-> months since year 0, so ranges can be walked across year boundaries
const toMonthIndex = (month: string) => {
  const [year, monthOfYear] = month.split('-').map(Number)
  return year * 12 + (monthOfYear - 1)
}

const fromMonthIndex = (index: number) => `${Math.floor(index / 12)}-${String((index % 12) + 1).padStart(2, '0')}`

// The API omits months without logs; fill them with zeros so every month in the range shows, newest first.
export const fillMonths = (from: string, to: string, months: MonthStats[]): MonthStats[] => {
  const statsByMonth = new Map(months.map((monthStats) => [monthStats.month, monthStats]))
  const filled: MonthStats[] = []
  for (let index = toMonthIndex(to); index >= toMonthIndex(from); index--) {
    const month = fromMonthIndex(index)
    filled.push(statsByMonth.get(month) ?? { month, totalAll: 0, totalSuccess: 0, byType: [], byGroup: [] })
  }
  return filled
}

// 'YYYY-MM' strings sort chronologically, so plain string comparison is enough
export const isValidMonthRange = (from: string, to: string) => !from || !to || from <= to

// blank bounds are left out so the API applies its default for them
export const toMonthRangeParams = (from: string, to: string) => {
  const params: Record<string, string> = {}
  if (from) params.from = from
  if (to) params.to = to
  return params
}

// the month picker works with Dates; the form, URL and API use 'YYYY-MM' (local time, so no timezone shift)
export const monthToDate = (month: string) => {
  if (!month) return null
  const [year, monthOfYear] = month.split('-').map(Number)
  return new Date(year, monthOfYear - 1, 1)
}

export const dateToMonth = (date: Date | null) =>
  date ? `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}` : ''
